import { baseApi } from "./baseApi";

const MAP_ADDRESS_BASE_URL = "/map-address";

export const mapAddressApi = baseApi.injectEndpoints({
  tagTypes: ["MapAddress"],

  endpoints: (builder) => ({
    createMapAddress: builder.mutation({
      query: (payload) => ({
        url: `${MAP_ADDRESS_BASE_URL}/create`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [{ type: "MapAddress", id: "LIST" }],
    }),

    getMapAddressList: builder.query({
      query: (params) => ({
        url: `${MAP_ADDRESS_BASE_URL}/list`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result?.data.map(({ _id }) => ({
                type: "MapAddress",
                id: _id,
              })),
              { type: "MapAddress", id: "LIST" },
            ]
          : [{ type: "MapAddress", id: "LIST" }],
    }),

    getAddressByName: builder.query({
      query: (name) => `${MAP_ADDRESS_BASE_URL}/name/${name}`,
    }),

    getAddressOptionsByKeyword: builder.query({
      query: (keyword) =>
        `https://nominatim.openstreetmap.org/search?format=json&q=${keyword}&countrycodes=np`,
    }),

    getMapAddressById: builder.query({
      query: (id) => `${MAP_ADDRESS_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "MapAddress", id },
        { type: "MapAddress", id: "LIST" },
      ],
    }),

    updateMapAddress: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;

        return {
          url: `${MAP_ADDRESS_BASE_URL}/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { id }) => [
        { type: "MapAddress", id },
        { type: "MapAddress", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useCreateMapAddressMutation,

  useGetMapAddressListQuery,
  useLazyGetMapAddressListQuery,
  useLazyGetAddressByNameQuery,

  useLazyGetAddressOptionsByKeywordQuery,

  useGetMapAddressByIdQuery,

  useUpdateMapAddressMutation,
} = mapAddressApi;
